import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const UserChangePassword = React.lazy(
  () => import('components/User/ChangePassword/ChangePassword'),
);

function ScreensUserChangePassword() {
  return (
    <BaseLayout>
      <DocumentTitle>Change Password</DocumentTitle>
      <UIPageTitle>Change Password</UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <UserChangePassword />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensUserChangePassword;
